
export enum CaseStatus {
    CREATED = "CREATED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    PROVISIONAL_ABANDONED = "PROVISIONAL_ABANDONED",
    PROVISIONAL_COMPLETED = "PROVISIONAL_COMPLETED",
    ABANDONED = "ABANDONED",
}

export  type PatientData = {
    gender?: string;
    age?: number;
    displayName?: string;
    firstName?: string;
    lastName?: string;
    contactDetails?: { phone?: string; email?: string };
};

export type CaseData = {
    caseId: string;
    caseCode: string;
    digitCode: string;
    status: CaseStatus;
    date: number;
    visitDate?: number;
    visitReason: { name: string; id: string };
    patient: PatientData;
    chiefComplaint?: {
        id: string;
        name: string;
        shortname: string;
    };
    comment?: string;
    encounterText?: string;
};